<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMAgreementList' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToList')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card">
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXCMRelationForm
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations" />
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMRelationForm from './Form'
import Loader from '../../Layout/Loader'
import CreateMixins from './CreateMixins'

const { mapGetters, mapActions } = createNamespacedHelpers('excmrelation/create')

export default {
  mixins: [CreateMixins],
  components: {
    EXCMRelationForm,
    Loader
  },
  computed: {
    ...mapGetters([
      'error',
      'isLoading',
      'created',
      'violations'
    ])
  },
  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (created && this.$route.name !== 'FirmShow') {
        this.$router.go(-1)
      }
    }
  },
  data () {
    return {
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  methods: {
    ...mapActions([
      'create'
    ])
  }
}
</script>
